export const criarParticipante = (titulo, identificador, tipoIdentificador, subtitulo = '') => {
  return {
    titulo,
    subtitulo,
    identificador,
    tipoIdentificador
  }
}
